import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { AvatarWithName } from "../../components/Avatar";
import { SchoolAdminListViewModel } from "./schoolsApiSlice";

interface SchoolAdminsTableProps {
	admins: SchoolAdminListViewModel[];
}

export default function SchoolAdminsTable(props: SchoolAdminsTableProps) {
	const adminNameBodyTemplate = (row: SchoolAdminListViewModel) => {
		return (
			<AvatarWithName
				userId={Number(row.userId)}
				name={row.fullName}
				initials={row.initials}
				hasImage={row.hasImage}
			/>
		);
	};

	return (
		<DataTable
			value={props.admins}
			dataKey="userId"
			emptyMessage="No school admins found"
			stripedRows
			className="tbl tbl-data tbl-datatable min-w-[40rem] cursor-default"
			style={{ paddingTop: "16px" }}>
			<Column header="Name" body={adminNameBodyTemplate}></Column>
			<Column header="Username" field="userName"></Column>
			<Column header="Phone" field="phoneNumber"></Column>
			<Column header="Email" field="email"></Column>
		</DataTable>
	);
}
